import { Theme } from '@mui/material';
import { TypographyVariantsOptions, TypographyStyleOptions } from '@mui/material/styles/createTypography';

import { RobotoFont, AlumniSansFont, OpenSansFont } from './fonts';

export interface ExtendedTypographyOptions extends TypographyVariantsOptions {
  subtitle?: TypographyStyleOptions;
}

export const typographyOptions = (theme: Theme) => {
  return {
    allVariants: {
      margin: 0,
    },
    h1: {
      fontFamily: `${AlumniSansFont.style.fontFamily}, sans-serif`,
      fontWeight: 400,
      fontStyle: 'normal',
      fontSize: '60px',
      lineHeight: '67px',
      [theme.breakpoints.down('md')]: {
        fontWeight: 400,
        fontSize: '32px',
        lineHeight: '40px',
      },
    },
    h2: {
      fontFamily: `${AlumniSansFont.style.fontFamily}, sans-serif`,
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '40px',
      lineHeight: '56px',
      [theme.breakpoints.down('md')]: {
        fontSize: '32px',
        lineHeight: '56px',
      },
    },
    h3: {
      fontFamily: `${AlumniSansFont.style.fontFamily}, sans-serif`,
      fontWeight: 400,
      fontSize: '28px',
      lineHeight: '48px',
      // [theme.breakpoints.down('md')]: {
      //   fontSize: '28px',
      //   lineHeight: '48px',
      // },
    },
    h4: {
      fontFamily: `${AlumniSansFont.style.fontFamily}, sans-serif`,
      fontWeight: 400,
      fontSize: '20px',
      lineHeight: '36px',
    },
    body1: {
      fontFamily: `${RobotoFont.style.fontFamily}, sans-serif`,
      fontWeight: 300,
      fontSize: '18px',
      lineHeight: '30px',
      letterSpacing: '-.75px',

      [theme.breakpoints.down('md')]: {
        fontWeight: 300,
        lineHeight: '24px',
      },
    },
    body2: {
      fontFamily: `${RobotoFont.style.fontFamily}, sans-serif`,
      fontWeight: 400,
      fontSize: '12px',
      lineHeight: '20px',
    },
    button: {
      fontFamily: `${RobotoFont.style.fontFamily}, sans-serif`,
      fontWeight: 400,
      fontSize: '16px',
      lineHeight: '20px',
      letterSpacing: '2px',
      [theme.breakpoints.down('md')]: {
        fontSize: '14px',
      },
    },
    subtitle: {
      fontFamily: OpenSansFont.style.fontFamily,
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '14px',
      letterSpacing: '0.2rem',
      textTransform: 'uppercase',
      lineHeight: '20px',
      margin: 0,
      [theme.breakpoints.down('md')]: {
        fontSize: '12px',
        lineHeight: '12px',
      },
    },
  } as ExtendedTypographyOptions;
};
